import { getENV } from "../utils";
import { initializeAmplitude } from "./amplitude";
import { initializeNewRelic } from "./newRelic";

export const initializeThirdPartyIntegrations = (): void => {
  const environment = getENV();

  initializeAmplitude(environment);
  initializeNewRelic(environment);
};
